import { PageFilters } from '@hopskipdrive/react-components';

import { DateFilter } from './DateFilter';
import { QuerySearch } from './QuerySearch';

export const FilterPanel = () => (
  <PageFilters>
    <DateFilter />
    <QuerySearch />
  </PageFilters>
);
